<template>
	<div class="sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label">{{ getMessage_('MWCC000346') }}</span>
		<!--MWCC000753-->
		<div class="search-option-wrapper__normal">
			<el-select v-model="data" @change="change">
				<el-option :label="getMessage_('MWCC000753')" value=""></el-option>
				<el-option :key="index" v-for="(item, index) in carCdList" :label="item.commCdName" :value="item.commCd"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/GraphInfo/store/helpers';
export default {
	data() {
		return {
			data: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		change(value) {
			this.setSearchParam_({ key: 'carCd', value: value });
			/*
			this.setSearchParam_({ key: 'carCd', value: value }).then(() => {
				this.$emit('reload', 1, 10);
			});
			*/
		}
	},
	created() {
		if (this.searchParams.carCd == null || this.searchParams.carCd == '') this.searchParams.carCd = '';
		this.data = this.searchParams.carCd;
	}
};
</script>

<style></style>
